/**
 * @category Chain Grpc Transformer
 */
export class ChainGrpcMintTransformer {
    static moduleParamsResponseToModuleParams(response) {
        const params = response.params;
        return params;
    }
}
//# sourceMappingURL=ChainGrpcMintTransformer.js.map